import clsx from "clsx";
import {
  arrayOf,
  element,
  func,
  node,
  number,
  oneOfType,
  shape,
  string,
} from "prop-types";
import { useState } from "react";
import SplitPane from "react-split-pane";
import Pane from "react-split-pane/lib/Pane";

import classes from "./SplitVerticalPanels.module.scss";

/**
 * Big note here: the documentation, and even the TS types are totally
 * different to what the _actual_ source-code supports. For instance,
 * the size={} prop is NOT defined in either - but when I checked the
 * code, it's right there, setting the active, current size. Total PITA.
 */
const SplitVerticalPanels = ({
  defaultSize = 100,
  panels = [],
  minSize = 50,
  className = "",
  onResizeStart = () => {},
  onResizeEnd = () => {},
}) => {
  const [widths, setWidths] = useState(panels.map((p) => p.initialSize));
  return (
    <SplitPane
      className={clsx(classes["split_vertical_panels"], className)}
      split="vertical"
      minSize={minSize}
      defaultSize={defaultSize}
      onResizeStart={onResizeStart}
      onResizeEnd={(sizes) => {
        setWidths(sizes);
        onResizeEnd(sizes);
      }}
    >
      {panels.map(
        (
          { children, className: paneClassName, initialSize, size, ...panel },
          index
        ) => {
          const paneSize = size ?? widths[index] ?? initialSize;

          return (
            <Pane
              className={clsx(
                classes["split_vertical_panels__pane"],
                paneClassName
              )}
              initialSize={paneSize}
              size={paneSize}
              key={index}
              {...panel}
            >
              {children}
            </Pane>
          );
        }
      )}
    </SplitPane>
  );
};

SplitVerticalPanels.propTypes = {
  defaultSize: number,
  panels: arrayOf(
    shape({
      initialSize: oneOfType([number, string]),
      size: oneOfType([number, string]),
      minSize: oneOfType([number, string]),
      maxSize: oneOfType([number, string]),
      className: string,
      children: oneOfType([node, element, string]),
    })
  ),
  minSize: number,
  className: string,
  onResizeStart: func,
  onResizeEnd: func,
};

export default SplitVerticalPanels;
